// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'prd',
  endpointJson: 'https://prd-apac-ap-southeast-1-s3-config.s3-ap-southeast-1.amazonaws.com/config-internal.json',
  configBasePath: 'https://prd-apac-ap-southeast-1-s3-config.s3-ap-southeast-1.amazonaws.com',
  cesAPI: {
    apiKey: 'Wq0doRzUXu1HYVU4Gsoqu11b6FFInp7157fyDy8L'
  },
  cognito: {
    userPoolId: 'ap-southeast-1_UIIXwjIv1',
    clientId: '5cmgos3g8gdjrtc015jjee4i8m',
    identityPoolId: 'ap-southeast-1:24d5e70e-3d41-43b3-b082-7e07e4a69307',
    region: 'ap-southeast-1',
    idpUrl: 'login.microsoftonline.com/548d26ab-8caa-49e1-97c2-a1b1a06cc39c',
    azureAppId: 'c3468ae8-1524-4366-9539-9e98f940e1b6',
  },
  siteUrl: 'https://apac.datamart-ss.gcds.coke.com/',
  internalHost: 'apac-internal.gcds.coke.com',
  publicHost: 'apac.gcds.coke.com',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts